import styled from 'styled-components';
import Button from 'components/Base/Button/Button';
import { DatePicker } from 'components/Base/DatePicker';

export const SDatePicker = styled(DatePicker)`
  &.ant-picker {
    width: fit-content !important;
    min-width: auto !important;
    padding: 0 !important;
    background-color: transparent !important;

    .ant-picker-input {
      & input {
        cursor: pointer;
        width: 100px;
        text-align: left !important;
      }
    }
  }
`;

export const StyledAddDateButton = styled(Button)`
  transition: all 0.2s ease;
  height: 40px;
  border-radius: 4px;
  padding: 0;
  color: #414042;
  background-color: transparent !important;

  &:hover {
    background-color: transparent !important;
  }
  &:focus,
  &:focus-within,
  &:active,
  &:focus-visible {
    border-color: transparent !important;
    box-shadow: none !important;
    outline: none !important;
    color: #414042 !important;
  }
  .ant-wave {
    display: none !important;
  }
`;
